/* eslint-disable react/display-name */
import { Box, Button, Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { getImage, ImageSize } from '../../../../../shared/utils/imageFormat';
import VideofilePlayer from '../ui/VideofilePlayer';

const slideTypes = require('../../../../../shared/schemas/entities/entitySlide.json');

const useStyles = makeStyles((theme) => ({
  slideContainer: {
    minHeight: 60,
  },
  slide: {
    minHeight: 60,
    position: 'relative',
    backgroundColor: theme.palette.background.shadedown_20,
    margin: theme.spacing(1),
    boxShadow:
      'rgb(0 0 0 / 20%) 0px 1px 8px 0px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 3px 3px -2px',
  },
  noSlide: {
    margin: theme.spacing(1),
  },
  image: {
    width: '100%',
    display: 'block',
  },
  imageHolder: {
    width: '100%',
  },
  slideNr: {
    position: 'absolute',
    top: 3,
    left: 3,
    height: 17,
    lineHeight: '17px',
    padding: '0 5px',
    fontSize: 10,
    fontWeight: 600,
    backgroundColor: '#000',
    color: '#ffffff',
    borderRadius: 10,
    opacity: 0.6,
    userSelect: 'none',
  },
  embedHolder: {
    width: '100%',
    height: 0,
    position: 'relative',
    paddingBottom: '56.25%',
    backgroundColor: '#000000',
  },
  embed: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  slideText: {
    whiteSpace: 'pre-wrap',
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxWidth: 600,
    fontSize: '1rem',
  },
  slideLink: {},
}));

export const EntitySlide = React.memo((props) => {
  const classes = useStyles();
  const typeRender = {
    video: (data) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        <Box className={classes.embedHolder}>
          <VideofilePlayer
            mux_asset_id={data.data.mux_asset_id}
            jwt={data.data.jwt}
            thumb_jwt={data.data.thumb_jwt}
          />
        </Box>
      </Box>
    ),
    text: (data) => (
      <Box
        p={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        <Box className={classes.slideText}>{data.data.text}</Box>
      </Box>
    ),
    note: (data) => (
      <Box
        p={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        <Box className={classes.slideText}>{data.data.text}</Box>
      </Box>
    ),
    links: (data) => (
      <Box
        p={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        {data.data.links.map((link, index) => (
          <Box
            key={index}
            display="inline-block"
            className={classes.slideLink}
            p={1}
          >
            <Button
              startIcon={<Icon>launch</Icon>}
              variant="contained"
              href={link.url}
              target="_blank"
              color="primary"
              rel="nofollow"
            >
              {link.text}
            </Button>
          </Box>
        ))}
      </Box>
    ),
    image: (data) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        <Box className={classes.imageHolder}>
          <img
            className={classes.image}
            src={getImage(data.data.src, ImageSize.Large)}
          />
        </Box>
      </Box>
    ),
    iframe: (data) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slideContainer}
      >
        <Box className={classes.embedHolder}>
          <iframe
            frameBorder="0"
            allow="fullscreen;camera;microphone"
            className={classes.embed}
            src={data.data.src}
          />
        </Box>
      </Box>
    ),
  };
  return (
    <Box
      className={
        slideTypes.properties[props.data.type] &&
        slideTypes.properties[props.data.type].noslide
          ? classes.noSlide
          : classes.slide
      }
    >
      {typeRender[props.data.type](props.data)}
      {/* <Box className={classes.slideNr}>{props.index || 0}</Box>*/}
    </Box>
  );
});
